import React from "react";
import { Nav, Navbar } from "react-bootstrap";

export default function CustomFooter() {
  return (
    <div>
      <Navbar
        bg="light"
        variant="light"
        fixed={
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
            ? ""
            : "bottom"
        }
        style={{ maxWidth: "100%", padding: "0.5rem" }}
      >
        <Nav className="m-auto">
          <Nav.Link className="pe-4" href="/hints" style={{ color: "#198754" }}>
            Wichtige Hinweise
          </Nav.Link>
          <Nav.Link className="ps-3" href="/privacy">
            Datenschutzerklärung
          </Nav.Link>
        </Nav>
      </Navbar>
    </div>
  );
}
